import React from "react";
import error from '../images/error.gif'
import btnHome from '../images/btnHomeIcon.png'

const Blacklist = () => {
  return (
    <div className="topicSection">

      {/* HOME BUTTON SECTION */}
      <div className="btnHomeSection bounce-in-fwd10">
        <button type="button" className="btnCircle">
          <img src={btnHome} alt="Date" height="50" width="50" /><br />
          HOME
        </button>
      </div>

      <div className="headerSub">
        <div className="headerSubTitle TextBig fcolorRed scale-in-center">
          <p>
            BLACK LIST
          </p>
        </div>
      </div>

      <div className="headerName">
        <div className="headerTitle">
          {/* <h1>
            <div className="iconWard"></div>
            xxxxx
            </h1> */}
        </div>
      </div>


      {/* MAIN CONTENT SECTION */}
      <div className="contentPage"> 
        {/* PLEASE MESSAGE  */}
        <div className="messageInfo fade-in-left3">
          <p>
            Please approach our staff for further assistance.
          </p>
        </div> 

        {/* ICON BOX */}
        <div className="iconSection2 iconCenter flip-in-hor-top2">
          <img className="fade-in3" src={error} alt="error" height="600" width="600" />
        </div> 
      </div>

    </div>
  );
}

export default Blacklist;